import {
  ACCOMMODATION_SERVICES_SECTOR,
  ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
  ARTS_ENTERTAINMENT_SECTOR,
  CONSTRUCTION_SECTOR,
  EDUCATIONAL_SERVICES_SECTOR,
  FINANCE_AND_INSURANCE_SECTOR,
  FISHING_AND_HUNTING_SECTOR,
  HEALTH_CARE_SECTOR,
  INFORMATION_SECTOR,
  MANAGEMENT_OF_COMPANIES_SECTOR,
  MANUFACTURING_SECTOR,
  MINING_QUARRYING_OIL_AND_GAS_SECTOR,
  OTHER_SERVICES_SECTOR,
  PUBLIC_ADMINISTRATION_SECTOR,
  REAL_ESTATE_SECTOR,
  RETAIL_TRADE_SECTOR,
  SCIENTIFIC_SERVICES_SECTOR,
  TRANSPORTATION_AND_WAREHOUSING_SECTOR,
  UTILITIES_SECTOR,
  WHOLESALE_TRADE_SECTOR,
} from '../industrySectorOptions';
import {
  ACCOMMODATION_SUB_SECTOR,
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  ADMINISTRATIVE_SERVICE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
  AIR_TRANSPORTATION_SUB_SECTOR,
  AMBULATORY_CARE_SUB_SECTOR,
  AMUSEMENT_INDUSTRY_SUB_SECTOR,
  ANIMAL_AND_AGRICULTURE_SUB_SECTOR,
  APPAREL_MANUFACTURING_SUB_SECTOR,
  BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
  BROADCASTING_PROVIDER_SUB_SECTOR,
  BUILDING_CONSTRUCTION_SUB_SECTOR,
  BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
  CHEMICAL_MANUFACTURING_SUB_SECTOR,
  CLOTHING_RETAILERS_SUB_SECTOR,
  COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  COURIERS_SUB_SECTOR,
  CREDIT_INTERMEDIATION_SUB_SECTOR,
  CROP_PRODUCTION_SUB_SECTOR,
  DURABLE_GOODS_SUB_SECTOR,
  EDUCATIONAL_SERVICES_SUB_SECTOR,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
  FISHING_HUNTING_TRAPPING_SUB_SECTOR,
  FOOD_MANUFACTURING_SUB_SECTOR,
  FOOD_RETAILERS_SUB_SECTOR,
  FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
  FORESTRY_AND_LOGGING_SUB_SECTOR,
  FUNDS_TRUSTS_SUB_SECTOR,
  FURNITURE_MANUFACTURING_SUB_SECTOR,
  FURNITURE_RETAILERS_SUB_SECTOR,
  GASOLINE_DEALERS_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
  HOSPITALS_SUB_SECTOR,
  INSURANCE_CARRIERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LAUNDRY_SERVICE_SUB_SECTOR,
  LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MACHINERY_MANUFACTURING_SUB_SECTOR,
  MERCHANDISE_RETAILERS_SUB_SECTOR,
  MINING_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MISCELLANEOUS_MANUFACTURING_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MOTION_PIC_INDUSTRIES_SUB_SECTOR,
  MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  NONDURABLE_GOODS_SUB_SECTOR,
  NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
  NURSING_FACILITIES_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PAPER_MANUFACTURING_SUB_SECTOR,
  PERFORMING_ARTS_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  PIPELINE_TRANSPORTATION_SUB_SECTOR,
  PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRIMARY_METAL_MANUFACTURING_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  PUBLISHING_INDUSTRIES_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  REAL_ESTATE_SUB_SECTOR,
  RELIGIOUS_SUB_SECTOR,
  RENTAL_AND_LEASING_SUB_SECTOR,
  REPAIR_AND_MAINTENANCE_SUB_SECTOR,
  SCENIC_TRANSPORTATION_SUB_SECTOR,
  SECURITIES_COMMODITY_SUB_SECTOR,
  SOCIAL_ASSISTANCE_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
  SPORTING_GOODS_RETAILERS_SUB_SECTOR,
  SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
  TELECOMMUNICATION_SUB_SECTOR,
  TEXTILE_MILLS_SUB_SECTOR,
  TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
  TRANSIT_TRANSPORTATION_SUB_SECTOR,
  TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  TRUCK_TRANSPORTATION_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WASTE_MANAGEMENT_SUB_SECTOR,
  WATER_TRANSPORTATION_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
  WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const SUB_SECTOR_OPTIONS_UA = {
  [FISHING_AND_HUNTING_SECTOR]: [
    { value: CROP_PRODUCTION_SUB_SECTOR, label: 'Вирощування сільськогосподарських культур' },
    { value: ANIMAL_AND_AGRICULTURE_SUB_SECTOR, label: 'Тваринництво та аквакультура' },
    { value: FORESTRY_AND_LOGGING_SUB_SECTOR, label: 'Лісове господарство та лісозаготівля' },
    { value: FISHING_HUNTING_TRAPPING_SUB_SECTOR, label: 'Рибальство, полювання та відлов тварин' },
    {
      value: AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
      label: 'Допоміжна діяльність у сільському та лісовому господарстві',
    },
  ],
  [MINING_QUARRYING_OIL_AND_GAS_SECTOR]: [
    { value: OIL_GAS_EXTRACTION_SUB_SECTOR, label: 'Добування нафти й газу' },
    { value: MINING_SUB_SECTOR, label: 'Гірничодобувна промисловість (крім нафти й газу)' },
    { value: MINING_SUPPORT_ACTIVITIES_SUB_SECTOR, label: 'Допоміжна діяльність у сфері видобутку корисних копалин' },
  ],
  [UTILITIES_SECTOR]: [],
  [CONSTRUCTION_SECTOR]: [
    { value: BUILDING_CONSTRUCTION_SUB_SECTOR, label: 'Будівництво будівель' },
    {
      value: HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
      label: 'Будівництво об’єктів інженерної інфраструктури',
    },
    { value: SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR, label: 'Спеціалізовані будівельні роботи' },
  ],
  [MANUFACTURING_SECTOR]: [
    { value: FOOD_MANUFACTURING_SUB_SECTOR, label: 'Виробництво харчових продуктів' },
    { value: BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR, label: 'Виробництво напоїв і тютюнових виробів' },
    { value: TEXTILE_MILLS_SUB_SECTOR, label: 'Текстильні фабрики' },
    { value: TEXTILE_PRODUCT_MILLS_SUB_SECTOR, label: 'Виробництво текстильних виробів' },
    { value: APPAREL_MANUFACTURING_SUB_SECTOR, label: 'Виробництво одягу' },
    {
      value: LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
      label: 'Виробництво шкіряних та споріднених виробів',
    },
    { value: WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR, label: 'Виробництво виробів з дерева' },
    { value: PAPER_MANUFACTURING_SUB_SECTOR, label: 'Виробництво паперу' },
    { value: PRINTING_MANUFACTURING_SUB_SECTOR, label: 'Поліграфічна діяльність і пов’язані допоміжні послуги' },
    { value: PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR, label: 'Виробництво нафтопродуктів і продуктів з вугілля' },
    { value: CHEMICAL_MANUFACTURING_SUB_SECTOR, label: 'Хімічне виробництво' },
    { value: PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR, label: 'Виробництво гумових і пластмасових виробів' },
    { value: NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR, label: 'Виробництво неметалевих мінеральних виробів' },
    { value: PRIMARY_METAL_MANUFACTURING_SUB_SECTOR, label: 'Виробництво первинних металів' },
    { value: FABRICATED_METAL_MANUFACTURING_SUB_SECTOR, label: 'Виробництво готових металевих виробів' },
    { value: MACHINERY_MANUFACTURING_SUB_SECTOR, label: 'Виробництво машин і устаткування' },
    {
      value: COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
      label: 'Виробництво комп’ютерної та електронної продукції',
    },
    {
      value: ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
      label: 'Виробництво електричного обладнання, побутової техніки та комплектувальних виробів',
    },
    { value: TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR, label: 'Виробництво транспортного обладнання' },
    { value: FURNITURE_MANUFACTURING_SUB_SECTOR, label: 'Виробництво меблів та споріднених виробів' },
    { value: MISCELLANEOUS_MANUFACTURING_SUB_SECTOR, label: 'Інші види виробництва' },
  ],
  [WHOLESALE_TRADE_SECTOR]: [
    { value: DURABLE_GOODS_SUB_SECTOR, label: 'Оптові торговці товарами тривалого користування' },
    { value: NONDURABLE_GOODS_SUB_SECTOR, label: 'Оптові торговці товарами короткострокового користування' },
    { value: AGENTS_AND_BROKERS_SUB_SECTOR, label: 'Агенти та брокери оптової торгівлі' },
  ],
  [RETAIL_TRADE_SECTOR]: [
    { value: MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR, label: 'Автосалони та продавці запчастин' },
    {
      value: BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
      label: 'Продавці будівельних матеріалів, садового обладнання та приладдя',
    },
    { value: FOOD_RETAILERS_SUB_SECTOR, label: 'Роздрібні продавці продуктів харчування та напоїв' },
    {
      value: FURNITURE_RETAILERS_SUB_SECTOR,
      label: 'Роздрібні продавці меблів, товарів для дому, електроніки та побутової техніки',
    },
    { value: MERCHANDISE_RETAILERS_SUB_SECTOR, label: 'Роздрібні продавці товарів широкого вжитку' },
    { value: HEALTH_RETAILERS_SUB_SECTOR, label: 'Роздрібні продавці товарів для здоров’я та особистої гігієни' },
    { value: GASOLINE_DEALERS_SUB_SECTOR, label: 'Автозаправні станції та продавці пального ' },
    { value: CLOTHING_RETAILERS_SUB_SECTOR, label: 'Роздрібні продавці одягу, аксесуарів, взуття та прикрас' },
    {
      value: SPORTING_GOODS_RETAILERS_SUB_SECTOR,
      label: 'Роздрібні продавці спортивних товарів, товарів для хобі, музичних інструментів, книжок та інших товарів',
    },
  ],
  [TRANSPORTATION_AND_WAREHOUSING_SECTOR]: [
    { value: AIR_TRANSPORTATION_SUB_SECTOR, label: 'Повітряні перевезення' },
    { value: RAIL_TRANSPORTATION_SUB_SECTOR, label: 'Залізничні перевезення' },
    { value: WATER_TRANSPORTATION_SUB_SECTOR, label: 'Водні перевезення' },
    { value: TRUCK_TRANSPORTATION_SUB_SECTOR, label: 'Автомобільні вантажні перевезення' },
    { value: TRANSIT_TRANSPORTATION_SUB_SECTOR, label: 'Міські та приміські пасажирські перевезення' },
    { value: PIPELINE_TRANSPORTATION_SUB_SECTOR, label: 'Трубопровідний транспорт' },
    { value: SCENIC_TRANSPORTATION_SUB_SECTOR, label: 'Екскурсійні та туристичні перевезення' },
    { value: SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR, label: 'Допоміжна діяльність у сфері транспорту' },
    { value: POSTAL_SERVICE_SUB_SECTOR, label: 'Поштова служба' },
    { value: COURIERS_SUB_SECTOR, label: 'Кур’єрські та послуги доставки' },
    { value: WAREHOUSING_AND_STORAGE_SUB_SECTOR, label: 'Складування та зберігання' },
  ],
  [INFORMATION_SECTOR]: [
    { value: MOTION_PIC_INDUSTRIES_SUB_SECTOR, label: 'Кінематографія та індустрія звукозапису' },
    { value: PUBLISHING_INDUSTRIES_SUB_SECTOR, label: 'Видавнича діяльність' },
    { value: BROADCASTING_PROVIDER_SUB_SECTOR, label: 'Мовлення та постачальники контенту' },
    { value: TELECOMMUNICATION_SUB_SECTOR, label: 'Телекомунікації' },
    {
      value: COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
      label: 'Постачальники обчислювальної інфраструктури, обробка даних, веб-хостинг та пов’язані послуги',
    },
    {
      value: WEB_SEARCH_PORTALS_SUB_SECTOR,
      label: 'Веб-портали пошуку, бібліотеки, архіви та інші інформаційні послуги',
    },
  ],
  [FINANCE_AND_INSURANCE_SECTOR]: [
    { value: MONETARY_BANK_SUB_SECTOR, label: 'Грошово-кредитні органи — центральний банк' },
    { value: CREDIT_INTERMEDIATION_SUB_SECTOR, label: 'Кредитне посередництво та пов’язані види діяльності' },
    {
      value: SECURITIES_COMMODITY_SUB_SECTOR,
      label: 'Цінні папери, товарні контракти, інші фінансові інвестиції та пов’язані види діяльності',
    },
    { value: INSURANCE_CARRIERS_SUB_SECTOR, label: 'Страхові компанії та пов’язана діяльність' },
    { value: FUNDS_TRUSTS_SUB_SECTOR, label: 'Фонди, трасти та інші фінансові інструменти' },
  ],
  [REAL_ESTATE_SECTOR]: [
    { value: REAL_ESTATE_SUB_SECTOR, label: 'Операції з нерухомістю' },
    { value: RENTAL_AND_LEASING_SUB_SECTOR, label: 'Послуги оренди та лізингу' },
    {
      value: LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
      label: 'Орендодавці нефінансових нематеріальних активів (крім об’єктів авторського права)',
    },
  ],
  [SCIENTIFIC_SERVICES_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],
  [ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR]: [
    { value: ADMINISTRATIVE_SERVICE_SUB_SECTOR, label: 'Адміністративні та допоміжні послуги' },
    { value: WASTE_MANAGEMENT_SUB_SECTOR, label: 'Послуги з управління відходами та рекультивації' },
  ],
  [EDUCATIONAL_SERVICES_SECTOR]: [{ value: EDUCATIONAL_SERVICES_SUB_SECTOR, label: 'Освітні послуги' }],
  [HEALTH_CARE_SECTOR]: [
    { value: AMBULATORY_CARE_SUB_SECTOR, label: 'Амбулаторні медичні послуги' },
    { value: HOSPITALS_SUB_SECTOR, label: 'Лікарні' },
    { value: NURSING_FACILITIES_SUB_SECTOR, label: 'Заклади догляду та проживання' },
    { value: SOCIAL_ASSISTANCE_SUB_SECTOR, label: 'Соціальна допомога' },
  ],
  [ARTS_ENTERTAINMENT_SECTOR]: [
    { value: PERFORMING_ARTS_SUB_SECTOR, label: 'Сценічне мистецтво, видовищний спорт та пов’язані індустрії' },
    { value: MUSEUMS_SUB_SECTOR, label: 'Музеї, історичні місця та подібні заклади' },
    { value: AMUSEMENT_INDUSTRY_SUB_SECTOR, label: 'Індустрія розваг, азартних ігор та відпочинку' },
  ],
  [ACCOMMODATION_SERVICES_SECTOR]: [
    { value: ACCOMMODATION_SUB_SECTOR, label: 'Розміщення' },
    { value: FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR, label: 'Заклади харчування та питні заклади' },
  ],
  [OTHER_SERVICES_SECTOR]: [
    { value: REPAIR_AND_MAINTENANCE_SUB_SECTOR, label: 'Ремонт і технічне обслуговування' },
    { value: LAUNDRY_SERVICE_SUB_SECTOR, label: 'Особисті послуги та послуги прання білизни' },
    {
      value: RELIGIOUS_SUB_SECTOR,
      label: 'Релігійні, благодійні, громадські, професійні та подібні організації',
    },
    { value: PRIVATE_HOUSEHOLDS_SUB_SECTOR, label: 'Приватні домогосподарства' },
  ],
  [PUBLIC_ADMINISTRATION_SECTOR]: [
    {
      value: EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
      label: 'Виконавча, законодавча влада та інша загальна підтримка державного управління',
    },
    { value: JUSTICE_PUBLIC_ORDER_SUB_SECTOR, label: 'Правосуддя, громадський порядок та безпека' },
    {
      value: ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
      label: 'Адміністрування програм у сфері людських ресурсів ',
    },
    {
      value: ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
      label: 'Адміністрування програм з охорони довкілля ',
    },
    {
      value: ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
      label: 'Адміністрування житлових програм, містобудування та розвитку громад',
    },
    { value: ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR, label: 'Адміністрування економічних програм' },
    { value: SPACE_RESEARCH_SUB_SECTOR, label: 'Космічні дослідження та технології' },
    { value: NATIONAL_SECURITY_SUB_SECTOR, label: 'Національна безпека та міжнародні відносини' },
  ],
};
